// extracted by mini-css-extract-plugin
module.exports = {"btn-submit":"formRequestActivate_btn-submit__2gSWo","field-group":"formRequestActivate_field-group__K7MG6","form":"formRequestActivate_form__20qng"};